var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgentPortalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 105,
    viewBox: "0 0 128 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7153_14145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.38672 11.0981H38.7532H41.6417C33.5539 18.0306 31.211 33.8853 31.0505 40.9461C34.9019 64.8244 56.7261 70.473 67.1569 70.3125C81.0217 67.2315 84.4879 63.8936 84.4879 62.6099C106.441 47.5896 95.2396 22.0103 86.895 11.0981H118.669V88.6064H9.38672V11.0981Z",
    fill: "url(#paint0_linear_7153_14145)",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6749 66.7974C93.585 59.793 101.615 40.4065 94.6108 23.4965C87.6064 6.58638 68.2199 -1.44377 51.3098 5.56061C34.3997 12.565 26.3696 31.9515 33.374 48.8616C40.3783 65.7716 59.7648 73.8018 76.6749 66.7974Z",
    fill: "url(#paint1_linear_7153_14145)",
    fillOpacity: 0.31,
    stroke: "#187C85",
    strokeWidth: 2.16638,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6655 29.9736H52.3371C51.2578 29.9736 50.3828 30.8486 50.3828 31.928V47.5625C50.3828 48.6418 51.2578 49.5168 52.3371 49.5168H75.6655C76.7449 49.5168 77.6198 48.6418 77.6198 47.5625V31.928C77.6198 30.8486 76.7449 29.9736 75.6655 29.9736Z",
    stroke: "#187C85",
    strokeWidth: 2.16638,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8723 17.4258H67.1055C70.9524 17.4258 74.0793 20.5527 74.0793 24.3996V29.9951H53.8984V24.3996C53.8984 20.5527 57.0253 17.4258 60.8723 17.4258Z",
    stroke: "#187C85",
    strokeWidth: 2.16638,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4425 36.2896H62.5625",
    stroke: "#187C85",
    strokeWidth: 2.16638,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 43.2017V36.2896",
    stroke: "#187C85",
    strokeWidth: 2.16638,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7994 10.3892H113.044C116.377 10.3892 119.093 13.1046 119.093 16.4373V89.9402H8.91016V16.4373C8.91016 13.1046 11.6256 10.3892 14.9583 10.3892H43.2033",
    stroke: "#187C85",
    strokeWidth: 2.16638,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.22 89.9409C125.22 96.565 120.222 101.955 114.05 101.955H13.9478C7.77628 101.955 2.77734 96.5856 2.77734 89.9409H125.22Z",
    stroke: "#187C85",
    strokeWidth: 2.16638,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7153_14145",
    x1: -141.64,
    y1: 100.721,
    x2: 54.9932,
    y2: -161.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#ED1C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#53BCC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7153_14145",
    x1: 15.1645,
    y1: 75.1266,
    x2: 75.5685,
    y2: 23.2394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#ED1C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#53BCC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9B1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7153_14145"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 126.558,
    height: 103.023,
    fill: "white",
    transform: "translate(0.722656 0.988281)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentPortalIcon);
export default __webpack_public_path__ + "static/media/agent-portal-icon.23e35f43b724d3e8f33c94d212c47ed8.svg";
export { ForwardRef as ReactComponent };